import React from 'react';
import { SectionHeader } from '../SectionHeader';
import { CtaButton } from '../CtaButton';
import { pillars } from '../../data/salesCopy';
export function DifferenceSection() {
  return <section className="w-full bg-paper px-5 py-16 sm:py-24" data-id="element-142" data-mp="3ii8jybp5xk8j">
      <SectionHeader eyebrow="What makes this collection different?" title="Designed Around the Low Back Pain Assessment Process" data-id="element-143" data-mp="3ikv1n45rpg4h" />

      <div className="mx-auto mt-8 max-w-3xl space-y-4 text-center text-lg leading-relaxed text-slate-700" data-id="element-144" data-mp="2pucsblegaiim">
        <p data-id="element-145" data-mp="2uso25w4qwt0u">There are many resources about spinal anatomy, orthopedic tests, and rehabilitation techniques.</p>
        <p data-id="element-146" data-mp="2zr90tr4cn4n6">The challenge is organizing that information into a coherent assessment process. I structured this collection around five connected elements.</p>
      </div>

      <ol className="relative mx-auto mt-12 max-w-3xl" data-id="element-147" data-mp="f21pmvsn0zcf">
        <span className="absolute bottom-8 left-[27px] top-8 w-0.5 bg-brand-dark/30" aria-hidden="true" data-id="element-148" data-mp="f1jl7bvtnetf" />
        {pillars.map((p, i) => <li key={p.title} className="relative flex gap-5 pb-6 last:pb-0" data-id="element-149" data-mp="de90z6ruynve" data-mpi={i}>
            <span className="relative z-10 flex h-14 w-14 shrink-0 items-center justify-center rounded-full bg-navy-900 font-display text-2xl font-black text-brand ring-4 ring-paper" data-id="element-150" data-mp="dc4tyfynx8qw">
              {i + 1}
            </span>
            <div className="flex-1 rounded-2xl bg-white p-5 shadow-sm ring-1 ring-slate-200" data-id="element-151" data-mp="3vk42u5n5r3no">
              <h3 className="font-display text-2xl font-extrabold uppercase leading-tight text-ink" data-id="element-152" data-mp="3qkr8kztyiub2">{p.title}</h3>
              <p className="mt-1.5 text-base leading-relaxed text-slate-700" data-id="element-153" data-mp="3ltiuhqhomkrk">{p.body}</p>
            </div>
          </li>)}
      </ol>

      <div className="mx-auto mt-12 max-w-3xl space-y-4 text-center text-lg leading-relaxed text-slate-700" data-id="element-154" data-mp="3gvhbf5k9alg3">
        <p data-id="element-155" data-mp="3cv77rzjxs74e">
          The six volumes provide the learning framework, while the five specialized resources offer practical ways to organize and review the
          information.
        </p>
        <p className="text-base italic text-slate-600" data-id="element-156" data-mp="32vontj410lcc">
          This is an educational reference collection designed to complement your existing training and professional judgment, not replace them.
        </p>
      </div>

      <CtaButton label="Start Assessing With Structure" sub="One-time payment of $27 · Instant access · 7-day guarantee" data-id="element-157" data-mp="2y4ayrne5gt7w" />
    </section>;
}